export default "__VITE_ASSET__845e9901__"